export default function (value) {
  value = value.toString();
  if (!value.trim().length) {
    return { error: true, typeError: "Esse Campo é obrigatório!" };
  }
  return { error: false, typeError: "" };
}
